import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const me = async () => {
  const res = await httpRequest.get("/api/auth/me");
  return res;
};

export const checkPin = async (data: { pin: string }) => {
  return httpRequest.put("/api/auth/pin/check", data);
};

export const changePin = async (data: any) => {
  return httpRequest.put("/api/auth/pin", data);
};

export const login = async (data: any) => {
  const res = await httpRequest.post(`/api/auth/login`, data);
  return res;
};

export const logout = async () => {
  const res = await httpRequest.put("/api/auth/logout");
  return res;
};

export const forgot = async (data: any) => {
  const res = await httpRequest.put("/api/auth/forgot", data);
  return res;
};

export const verify = async (id: string) => {
  const res = await httpRequest.get(`/api/auth/${id}/verify`);
  return res;
};

export const createPin = async (data: any) => {
  const res = await httpRequest.post(`/api/auth/pin`, data);
  return res;
};

export const updatePin = async (data: any) => {
  const res = await httpRequest.put(`/api/auth/pin`, data);
  return res;
};

export const avatar = async (data: any) => {
  return httpRequest.put("/api/auth/avatar", data);
};

export const uploadImage = async (data: any) => {
  return httpRequest.upload(`/mdi/file/2fa/upload`, data);
};
